import { useEffect } from 'react';

export function usePackCookie() {
  useEffect(() => {
    fetch('/api/pack-cookie');
  }, []);
}